import * as React from 'react';

function SvgDevTheme(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={20} cy={20} r={20} fill="#00A2E1" />
      <circle cx={30.286} cy={26.857} r={1.714} fill="#00A2E1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.056 19.828c0 2.419-1.73 4.36-4.197 4.36s-4.196-1.941-4.196-4.36c0-2.419 1.73-4.36 4.196-4.36 2.467 0 4.197 1.941 4.197 4.36zm2.694 0c0-3.938-2.95-6.89-6.89-6.89-3.942 0-6.891 2.952-6.891 6.89 0 3.937 2.949 6.89 6.89 6.89 3.942 0 6.891-2.953 6.891-6.89zm1.969 6.89a1.312 1.312 0 100-2.624 1.312 1.312 0 000 2.625z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgDevTheme;
